import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import additionalMaterials from '@/components/features/additional-materials/index.vue';
import speakersMobile from '@/components/atoms/speakers-education-mobile/index.vue';
import lessonRate from '@/modules/courses/components/lesson-rate/index.vue';
import lessonRateComment from '@/modules/courses/components/lesson-rate-comment/index.vue';
import donate from '@/components/features/donate/index.vue';
import VideoPlayer from "@/components/video-player/index.vue";
import courseBanner from "@/components/features/course-banner/index.vue";
import marathonBanner from "@/components/features/marathon-banner/index.vue";
import widgetHost from "@/components/features/widget-host/index.vue";

import {seo} from '@/mixins/seo'

export default {
	name		: 'courses-lesson',
	mixins		: [seo],
	directives	: {
		onClickaway: onClickaway,
	},
	components	: {
		"course-banner": courseBanner,
		"marathon-banner": marathonBanner,
		"widget-host": widgetHost,
		donate,
		additionalMaterials,
		speakersMobile,
		lessonRate,
		lessonRateComment,
		VideoPlayer
	},
	watch		: {
		lesson() {
			this.startLesson();
			
			this.seo.title = this.lesson.name + ' - ' + this.lesson.course.data.name;
			
			Object.assign(this.seo, this.lesson.seo.data);
			
			this.$emit('updateHead');
			
			this.setPlaysinline();
		}
	},
	mounted() {
		//alert('lesson-detail');
		
		this.startLesson();
		
		// if (this.lesson.video.data.length) {
		//     this.selectedVideoId = this.lesson.video.data[0].id
		// }
		
		// Привет утечка памяти! А отписаться в destroyed ???
		// this.$bus.$on('event-select-video', video => {
		//   console.log('select video', video);
		//   // this.selectedVideoId = video.id
		// });
	},
	computed	: {
		...mapGetters({
			lesson				: 'coursesLesson/lesson',
			module				: 'coursesLesson/module',
			course				: 'courses/currentItem',
			isLoading			: 'coursesLesson/isLoading',
			isProgressLoading	: 'coursesLesson/isProgressLoading',
			selectedVideoId		: 'coursesLesson/selectedVideoId'
		}),
		activeIndex() {
			return this.module.materials.data.findIndex(e => e.id === this.lesson.id);
		},
		nextMaterial() {
			return this.module.materials.data[this.activeIndex + 1];
		},
		materialsList() {
			let concatMaterials = [];
			
			if (!!this.course && this.course.modules.data.length) {
				for (let module of this.course.modules.data) {
					concatMaterials = [
						...concatMaterials,
						...module.materials.data
					]
				}
				
				return concatMaterials
			}
		},
		nextActiveMaterial() {
			let currentSort = this.lesson.sort,
				list = this.materialsList,
				activeMaterial = null;
			
			if (typeof list !== 'undefined') {
				for (let item of list) {
					if (item.sort > currentSort) {
						let typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
						let status = item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new';
						
						if (
							status !== 'failed' && 
							status !== 'locked' && 
							status !== 'expired'
						) {
							activeMaterial = item;
							
							break;
						}
					}
				}
				
				return activeMaterial;
			}
		},
		currentMaterial() {
			return this.module.materials.data[this.activeIndex];
		},
		getStatusNextMaterialItem() {
			const item = this.nextActiveMaterial || this.nextMaterial;
			
			if (!item) {
				return 'locked'
			}
			
			const typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
			
			return item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new'
		},
		getStatusMaterialItem() {
			const item = this.currentMaterial;
			
			if (!item) {
				return 'locked'
			}
			
			const typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork'
			
			return item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new'
		},
		hasRate() {
			return this.lesson && this.lesson.userRating.data.rating;
		}
	},
	methods: {
		...mapActions({
			updateProgress	: 'coursesLesson/UPDATE_PROGRESS_LESSON'
		}),
		...mapMutations({
			setLesson		: 'coursesLesson/SET_CURRENT_ITEM'
		}),
		completeLesson() {
			this.updateProgress({
				item		: this.$route.params.item,
				moduleSlug	: this.$route.params.moduleSlug,
				slug		: this.lesson.slug,
				type		: 'complete'
			}).catch(error => {
				if (error.response.status === 403) {
					// this.$toasted.error(error.response.data.error.message_key);
				}
			})
		},
		startLesson() {
			if (this.lesson && this.lesson.userLesson.data.hasOwnProperty('id')) {
				if (
					this.lesson.userLesson.data.status !== 'processing' && 
					this.lesson.userLesson.data.status !== 'completed'
				) {
					this.updateProgress({
						item		: this.$route.params.item,
						moduleSlug	: this.$route.params.moduleSlug,
						slug		: this.lesson.slug,
						type		: 'start'
					}).catch(error => {
						if (error.response.status === 403) {
							// this.$toasted.error(error.response.data.error.message_key);
						}
					})
				}
			}
		},
		nextStep() {
			let nextMaterial = this.nextActiveMaterial || this.nextMaterial;
			
			if (!nextMaterial) return;
			
			const moduleSlug = this.course.modules.data.find(item => item.id === nextMaterial.moduleId).slug
			
			try {
				if (nextMaterial.material === 'lesson') {
					this.$router.push({
						name: 'courses-lesson-detail',
						params: {item: this.$route.params.item, moduleSlug, lessonSlug: nextMaterial.slug}
					})
				} else {
					this.$router.push({
						name: 'home-work-rules',
						params: {item: this.$route.params.item, moduleSlug, testId: nextMaterial.slug}
					})
				}
			} catch (e) {
				console.log('');
			}
		},
		setPlaysinline() {
			this.$nextTick(() => {
				var el = document.getElementsByTagName("iframe")[0];
				el.setAttribute("playsinline", 1);
			})
		},
		getCourse(){
			if(this.lesson){
				return {
					id : this.lesson.courseId
				}
			}
			
			return {
				id : 0
			}
		}
	},
	destroyed() {}
}
